import { useState, useRef } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";

import edit from "../../edit.png";
import trash from "../../trash.png";
import icoArrow from '../../Down_Arrow_3_.png'

import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";

import GroupKids from "./GroupKids"; 
import GroupNew from "./GroupNew";
import GroupEdit from "./GroupEdit";
import MenuTable from "../../helpers/MenuTable";
import AppContext from "../../AppContext";








function Group(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        fraza: '', 
        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    const tabRef = useRef(0); //do druku


    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,groups', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

    
    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {
        setFilterParam({
            fraza: '',         
            limit: 50,
            page: 1,
            show: true
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
    }





    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = () => {
       
        setView({...view, ["v"]:"list", ["id"]:-1 }); 
        getTab();
    }



    

    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

        var title = "";
        var iloscDzieci =0;
        for(var cx =0; cx<tab.length; cx++)
        {
            if(tab[cx].id == id) {  title = tab[cx].nazwa;  iloscDzieci = tab[cx].kids.length }
        }


        if(iloscDzieci > 0)
        {
            props.mainView.showDialog( "Error", "Nie można usunąć grupy, która zawiera dzieci. Przenieś dzieci do archiwum lub usuń z tej grupy." , "ok" , null);  
            return;   
        }


        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć grupę \""+title+"\"?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteApproved(id);
                        //--------
        } );
    }

    const goDeleteApproved = (id) => {

 
    

        props.mainView.setProgress(-2);

        var req = {
            id: id
        }

        fetch( Config.url + '/rest_v1_kids,groups_delete', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Grupa została usunięta", "ok" , null);                        
                        setTab(null);
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }




    if(view.v == 'new')
    {
        return <GroupNew  userData={props.userData} mainView={props.mainView} onBack={onBack} />
    }

    if(view.v == 'edit')
    {
        var searchRow = null;
        for(var k=0; k<tab.length; k++)
        {
            if(tab[k].id == view.id) { searchRow = tab[k]; break; }
        }

        return <GroupEdit  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack} />
    }
    

    return (

        <div className="view_content">
         

                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                 {
                    filterParam.show == true  &&
                    <div className="table_filter">
                    
                            <div className="filter_controll">   
                                <label>Fraza: </label>                             
                                <InputText   userData={props.userData} value={filterParam.fraza}   valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Fraza: "}   />
                            </div>  

                            <div className="filter_btn">
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>

                    </div>
                }   
        



            <div className="bg_center">


                    <div className="table_widget">
                              <div className="btn" onClick={changeView} v="new" id="-1"  > nowa grupa</div>

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                    </div>
 

                    <div className="scorll_x">
                            <table className="table" ref={tabRef}>
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                <td>Nazwa</td>
                                                <td>Rok szkolny</td>
                                                <td>Wiek od</td>
                                                <td>Wiek do</td>                               
                                                <td>Max. ilość dzieci</td>
                                                <td>Aktualna ilość dzieci</td>
                                                <td>Przypisani pracownicy</td>
                                                <td>Sala</td>
                                                <td className="td_right">Piętro</td>                                             
                                                <td className="td_option"> </td>
                                              
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var rowStyle = " row ";
                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle} key={ix}>
                                                            <td className="gocenter">{ix+1}</td>
                                                            <td onClick={changeView} v="edit" id={row.id}  className="link_normal" >{row.nazwa}</td>
                                                            <td className="gocenter">{row.rok_szkolny}</td>
                                                            <td className="gocenter">{row.wiek_od}</td>
                                                            <td className="gocenter">{row.wiek_do}</td>                               
                                                            <td className="gocenter">{row.max_ilosc_dzieci} </td>
                                                            <td className="gocenter"> <GroupKids tab={row.kids} />  </td>
                                                            <td className="gocenter"> <GroupKids tab={row.emps} />  </td>
                                                            <td className="gocenter">{row.salda}</td>
                                                            <td className="gocenter">{row.pietro}</td>                                                            

                                                            <MenuTable>
                                                                        <ul>
                                                                            <li onClick={changeView} v="edit" id={row.id} >zmień dane</li>
                                                                            <li onClick={goDelete}  id={row.id} >usuń</li>
                                                                        </ul>
                                                            </MenuTable>
                                                                
                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                                </table>
                    </div>
            </div>


        </div>

    )

    
}

export default Group;